<cdk-accordion [multi]="true">
  <cdk-accordion-item
    *ngFor="let item of menuItems; let index = index"
    #accordionItem="cdkAccordionItem"
  >
    <ng-container *ngIf="!item.children">
      <a
        [href]="cimbUrl + item.url"
        class="text-sm hover:underline mb-4 block focus-visible:outline-none"
      >
        {{ item.label }}
      </a>
    </ng-container>

    <ng-container *ngIf="item.children">
      <div class="mb-3">
        <div
          [ngClass]="{ 'pb-2': !accordionItem.expanded }"
          class="cursor-pointer relative flex items-center"
          (click)="accordionItem.toggle()"
        >
          <span class="pr-2 inline">
            <div class="text-sm hover:underline block break-words">{{ item.label }}</div>
          </span>
          <svg
            width="15"
            height="20"
            class="icon-bytesize icon-bytesize-primary ml-auto flex-none inline"
            [class]="accordionItem.expanded ? 'rotate-180' : 'rotate-0'"
          >
            <use
              attr.xlink:href="{{ '#i-chevron-bottom' | bytesizeIcon }}"
              stroke-width="3.5px"
            ></use>
          </svg>
        </div>
        <div
          class="overflow-hidden"
          [style.display]="accordionItem.expanded ? '' : 'none'"
        >
          <div class="mt-2 border-t border-b border-[#ededed] py-2">
            <a
              *ngFor="let itemChild of item.children"
              [href]="cimbUrl + itemChild.url"
              class="block py-2 my-3 text-sm hover:underline pl-4"
            >
              {{ itemChild.label }}
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </cdk-accordion-item>
</cdk-accordion>
